<template>
    <div id="footer">
        <footer class="container space-top-2 space-top-md-3">
            <div class="border-bottom">
                <div class="row mb-7">
                    <div class="col-lg-3 mb-7 mb-lg-0">
                        <div class="d-inline-flex align-self-start flex-column h-100">
                            <Logo/>
                        </div>
                    </div>

                    <div class="col-6 col-sm-4 col-md-3 col-lg-2 mb-4 mb-md-0">
                        <h4 class="h6 font-weight-semi-bold">Compte</h4>

                        <!-- List Group -->
                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                            <li><a class="list-group-item list-group-item-action" href="#">Inviter des amis</a></li>
                        </ul>
                        <!-- End List Group -->
                    </div>

                    <div class="col-6 col-sm-4 col-md-3 col-lg-2 mb-4 mb-md-0">
                        <h4 class="h6 font-weight-semi-bold">Organisation</h4>

                        <!-- List Group -->
                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                            <li>
                              <a class="list-group-item list-group-item-action"
                                 href="https://almeki.io" target="_blank">
                                A propos
                              </a>
                            </li>
                            <li>
                              <a class="list-group-item list-group-item-action"
                                 href="https://almeki.io" target="_blank">
                                Services
                              </a>
                            </li>
                            <li>
                              <a class="list-group-item list-group-item-action"
                                 href="https://almeki.io" target="_blank">
                                Nous rejoindre
                              </a>
                            </li>
                            <li>
                              <a class="list-group-item list-group-item-action"
                                 href="https://almeki.io" target="_blank">
                                Blog
                              </a>
                            </li>
                        </ul>
                        <!-- End List Group -->
                    </div>

                    <div class="col-sm-4 col-md-3 col-lg-2 mb-4 mb-md-0">
                        <h4 class="h6 font-weight-semi-bold">Resources</h4>

                        <!-- List Group -->
                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                            <li><a class="list-group-item list-group-item-action" href="https://almeki.io" target="_blank">Aide</a></li>
                            <li><a class="list-group-item list-group-item-action" href="https://almeki.io" target="_blank">Termes</a></li>
                            <li><a class="list-group-item list-group-item-action" href="https://almeki.io" target="_blank">Politique</a></li>
                        </ul>
                        <!-- End List Group -->
                    </div>

                    <div class="col-md-3 col-lg-2">
                        <h4 class="h6 font-weight-semi-bold">Contact</h4>

                        <!-- Address -->
                        <address>
                            <ul class="list-group list-group-flush list-group-borderless mb-0">
                                <li class="list-group-item">
                                    <a href="mailto:resolveneed@gmail.com">resolveneed@gmail.com</a>
                                </li>
                            </ul>
                        </address>
                        <!-- End Address -->
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center py-7">
                <!-- Copyright -->
                <p class="small text-muted mb-0">&copy; ResolveNeed. 2020 Almeki.</p>
                <!-- End Copyright -->

                <!-- Social Networks -->
                <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a class="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent"
                         href="https://twitter.com/resolveneed" target="_blank">
                        <span class="fab fa-twitter btn-icon__inner"></span>
                      </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent"
                           href="#">
                            <span class="fab fa-facebook-f btn-icon__inner"></span>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent" href="#">
                            <span class="fab fa-google btn-icon__inner"></span>
                        </a>
                    </li>

                    <li class="list-inline-item">
                        <a class="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent" href="#">
                            <span class="fab fa-github btn-icon__inner"></span>
                        </a>
                    </li>
                </ul>
                <!-- End Social Networks -->
            </div>
        </footer>
    </div>
</template>

<script>
    import Logo from "./Logo";

    export default {
        name: "FooterA",
        components: {Logo}
    }
</script>

<style scoped>

</style>